// extracted by mini-css-extract-plugin
export var avatarContainer = "_4o-1";
export var largeAvatarContainer = "_4o-2";
export var smallAvatarContainer = "_4o-0";